import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useSsoCallback, AuthErrorPage } from '@foundation-bb/foundation-auth-ui';
import { tokenReceived } from '@/store/authSlice';
import type { AppDispatch } from '@/store/store';

/**
 * Handles the SSO redirect. On success the access token arrives in the URL fragment (the refresh
 * cookie is already set by the server); we apply it and navigate. On `?error=` we render Foundation's
 * AuthErrorPage with the localized message for the error code.
 */
export default function SsoCallbackPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const [errorCode, setErrorCode] = useState<string | null>(null);

  useSsoCallback({
    onAuthenticated: ({ accessToken }) => {
      dispatch(tokenReceived({ accessToken }));
      navigate('/documents', { replace: true });
    },
    onError: (code) => setErrorCode(code),
  });

  if (errorCode) {
    return (
      <AuthErrorPage
        code={errorCode}
        t={t}
        labels={{
          title: t('auth.error.title'),
          backToSignIn: t('auth.sso.backToLogin'),
        }}
        renderBackLink={(label) => <Link to="/login">{label}</Link>}
      />
    );
  }

  return (
    <div style={{ maxWidth: 480, margin: '4rem auto', textAlign: 'center' }}>
      <p>{t('auth.sso.signingIn')}</p>
    </div>
  );
}
